import * as React from 'react';
import { getYouMayAlsoLikeProducts } from 'modules/product/youmayalsolike';
import { IProductsAction, IProductsData } from 'models/product/products';
import { IStore } from 'redux/IStore';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { IItemCardList } from 'models/itemcard/itemcardlist';
import { ItemCardList } from 'components';
import { ErrorPage } from 'containers';
import { IUserPreferences } from 'models/user/userpreferences';
import { getShopCard } from 'redux/modules/shop/shopcard';
import { goToCard } from 'helpers/common';
import { Wishlists } from 'redux/modules/user/wishlists';
import { WishlistNodeType } from 'models/enums/nodetype/wishlistnodetype';
import { LikeNodeType } from 'models/enums/nodetype/likenodetype';
import { Likes } from 'redux/modules/user/likes';
import { getProductCard } from 'redux/modules/product/productcard';
import { IProductCardDataAction } from 'models/product/productcard';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';
import { IAuthContext } from 'models/common';
const { connect } = require('react-redux');

interface IProps {
	userPreferences?: IUserPreferences;
	productsData?: IProductsData;
	id?: string;
	location?: any;

	/* function props */
	getYouMayAlsoLikeProducts?: (id: string) => IProductsAction;
	t?: (key: string) => string;
	getShopCard?: (id: string) => void;
	getProductCard?: (id: string) => IProductCardDataAction;
	dispatch?: any;
	context?: IAuthContext;
}

interface IYouMayAlsoLikeProductsItemCardList extends IItemCardList {
	wishlistItem?: (itemType: string, itemId: string) => void;
	unwishItem?: (itemType: string, itemId: string) => void;
}

@connect(
	(state: IStore) => ({
		productsData: state.youMayAlsoLikeProducts,
		userPreferences: state.userPreferences,
	}),
	(dispatch) => ({
		dispatch,
		getYouMayAlsoLikeProducts: (id: string) => dispatch(getYouMayAlsoLikeProducts(id)),
		getShopCard: (id: string) => dispatch(getShopCard(id)),
		getProductCard: (id: string) => dispatch(getProductCard(id)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class YouMayAlsoLikeProductsComponent extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.likeItem = this.likeItem.bind(this);
		this.unlikeItem = this.unlikeItem.bind(this);
		this.wishlist = this.wishlist.bind(this);
		this.unwish = this.unwish.bind(this);
		this.goToCard = this.goToCard.bind(this);
	}

	public componentDidMount() {
		this.props.getYouMayAlsoLikeProducts(this.props.id);
	}

	public componentDidUpdate(prevProps: IProps) {
		if (prevProps.id !== this.props.id) {
			this.props.getYouMayAlsoLikeProducts(this.props.id);
		}

		if (
			!prevProps.userPreferences.id &&
			this.props.userPreferences.id &&
			this.props.productsData &&
			this.props.productsData.items.length > 0
		) {
			const likes = new Likes(LikeNodeType.ProductsYouMayAlsoLike);
			this.props.dispatch(likes.getLikedItems());
		}
	}

	private likeItem(_, itemId: string) {
		const { isAuthenticated, signinRedirect } = this.props.context;
		if (isAuthenticated()) {
			const likes = new Likes(LikeNodeType.ProductsYouMayAlsoLike);
			this.props.dispatch(likes.likeItem(itemId));
		} else {
			signinRedirect();
		}
	}

	private unlikeItem(_, itemId: string) {
		const { isAuthenticated, signinRedirect } = this.props.context;
		if (isAuthenticated()) {
			const likes = new Likes(LikeNodeType.ProductsYouMayAlsoLike);
			this.props.dispatch(likes.unlikeItem(itemId));
		} else {
			signinRedirect();
		}
	}

	private wishlist(_, itemId: string) {
		const { isAuthenticated, signinRedirect } = this.props.context;
		if (isAuthenticated()) {
			const wishlists = new Wishlists(WishlistNodeType.ProductsYouMayAlsoLike);
			this.props.dispatch(wishlists.wishlist(itemId));
		} else {
			signinRedirect();
		}
	}

	private unwish(_, itemId: string) {
		const { isAuthenticated, signinRedirect } = this.props.context;
		if (isAuthenticated()) {
			const wishlists = new Wishlists(WishlistNodeType.ProductsYouMayAlsoLike);
			this.props.dispatch(wishlists.unwish(itemId));
		} else {
			signinRedirect();
		}
	}

	private goToCard(id: string, type: string) {
		goToCard(this.props.dispatch, id, type);
	}

	public render() {
		if (this.props.productsData.error) {
			return <ErrorPage {...this.props} message={this.props.productsData.message} />;
		}

		const { userPreferences, t } = this.props;

		let products = [];

		if (this.props.productsData !== undefined || this.props.productsData !== null) {
			products = this.props.productsData.items;
		}

		if (products.length === 0) {
			return null;
		}

		let isMyItem: boolean = false;
		if (userPreferences && userPreferences.userShops && userPreferences.userShops.length > 0) {
			isMyItem = userPreferences.userShops.find((x) => x.ownerId === userPreferences.id) ? true : false;
		}

		const listProps: IYouMayAlsoLikeProductsItemCardList = {
			items: products,
			itemType: c.NODE_TYPE_PRODUCT_ITEM_CARD,
			isMyItem,
			likeItem: this.likeItem,
			unlikeItem: this.unlikeItem,
			wishlistItem: this.wishlist,
			unwishItem: this.unwish,
			goToCard: this.goToCard,
		};

		return (
			<>
				<div className="leftHeader">
					<p>{t('Product_YouMayAlsoLike_Title')}</p>
				</div>
				<div className="productItemRow row">
					<ItemCardList {...listProps} />
				</div>
			</>
		);
	}
}
const YouMayAlsoLikeProducts = withAuthContext(YouMayAlsoLikeProductsComponent);
export { YouMayAlsoLikeProducts };
